import { computed, inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginRequest } from '../../features/login/models/login-request.model';
import { LoginResponse } from '../../features/login/models/login-response.model';
import { ConfigService } from '../config/config.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly configService = inject(ConfigService);
  private readonly apiSvc = inject(ApiService);
  private readonly companyKey = computed(
    () => this.configService.config()?.company.key ?? null,
  );

  constructor() {}

  login(request: LoginRequest): Observable<LoginResponse> {
    return this.apiSvc
      .postFullError<LoginResponse>(`Auth/authentication`, {
        email: request.username,
        password: request.password,
        companyKey: this.companyKey(),
        captchaaKey: '',
      })
      .pipe(map((u) => u));
  }

  refreshToken(
    accessToken: string,
    refreshToken: string,
  ): Observable<LoginResponse> {
    return this.apiSvc
      .post<LoginResponse>(`Auth/refresh-token`, {
        accessToken: accessToken,
        refreshToken: refreshToken,
      })
      .pipe(map((u) => u));
  }

  changeHotel(
    hotelId: string,
    accessToken: string,
    refreshToken: string,
  ): Observable<LoginResponse> {
    return this.apiSvc
      .post<LoginResponse>(`Auth/change/${hotelId}`, {
        accessToken: accessToken,
        refreshToken: refreshToken,
      })
      .pipe(map((u) => u));
  }

  setNewPassword(
    userId: string,
    hash: string,
    password: string,
    confirmPassword: string,
  ): Observable<any> {
    return this.apiSvc
      .post<any>(`Auth/SetNewPassword/${userId}/${hash}`, {
        password: password,
        confirmPassword: confirmPassword,
      })
      .pipe(map((u) => u));
  }

  resetPassword(email: string): Observable<any> {
    return this.apiSvc
      .post<any>(`Auth/ResetPassword`, {
        email: email,
        companyKey: this.companyKey(),
      })
      .pipe(map((u) => u));
  }

  tokenAuthentication(token: string): Observable<LoginResponse> {
    return this.apiSvc
      .post<LoginResponse>(`Auth/TokenAuthentication`, {
        token,
        companyKey: this.companyKey(),
      })
      .pipe(map((u) => u));
  }

  logout(): Observable<void> {
    return this.apiSvc.post<void>(`Auth/logout`, {}).pipe(map((u) => u));
  }
}
